<template>
  <td>
    <input list="listId" v-model="model" />

    <!--div class="debug">
            <p>displayOptions = {{ displayOptions }}</p>
        </div>-->
  </td>
  <datalist id="listId">
    <option
      v-for="(item, index) in options"
      :key="index"
      :value="item"
      :selected="selected == item"
    >
      {{ displayOptions[index] }}
    </option>
  </datalist>
</template>

<script setup lang="ts">
/**
 * Form listbox is input with type list, and datalist of options
 */

import { computed } from 'vue'
const props = defineProps({
  //name: { type: String, required: true },
  // placeholder: { type: String},
  options: { type: Array<any> }, //this should just be plain string arrays
  displayOptions: { type: Array<String> }
})

//generate random (hopefully unique) id
const listId = computed(() => {
  let x = Math.floor(Math.random() * 1000000 + 1)
  return `datalist-${props.name}-${x}`
})

const model = defineModel<any>('selected')
</script>

<style lang="css" scoped>
input {
  width: 100%;
  height: 2rem;
  border: none;
  outline: none;
  padding-left: 0.25rem;
  /*font-size:large;*/
}
input:focus {
  /*background-color: lightsteelblue;*/
  border: 1px solid var(--blue);
}
td {
  padding: 0;
  margin: 0;
}
</style>
